import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
export default {
  data: function data() {
    return {
      feedNum: 8,
      // フィード取得数
      insta_business_id: '17841408559416517',
      // Instagram ビジネス ID
      token: 'EAAHk9xthtXQBACev2IkT29ZBuDdV2VPKFvBQwzsEpswMWCENIR3OZCQwr3mZBEbgYliXkg2qmcYVFzlZBPmCgJGXAm4W8DDDpnV757tb0hI5vRhllZCOG7ZAG5wr1q6kb3rRrzNN6YNK48HQkw0Qzj3vq5oq7ux9EU5VdtIocPFgZDZD',
      // 第三トークン
      photoList: []
    };
  },
  computed: {
    api: function api() {
      return "https://graph.facebook.com/v4.0/".concat(this.insta_business_id, "?fields=media.limit(").concat(this.feedNum, "){caption,like_count,media_url,permalink,timestamp}&access_token=").concat(this.token);
    }
  },
  methods: {
    getPhotoList: function () {
      var _getPhotoList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _ref, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.photoList = null;
                _context.next = 4;
                return axios.get(this.api);

              case 4:
                _ref = _context.sent;
                data = _ref.data;
                // console.log(data.media.data);
                this.photoList = data.media.data;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log("Error! HTTP states: ".concat(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function getPhotoList() {
        return _getPhotoList.apply(this, arguments);
      }

      return getPhotoList;
    }()
  },
  mounted: function mounted() {
    this.getPhotoList();
  }
};